import Vue from 'vue'
import axios from 'axios'
import { api } from './interface_api'
import VueAxios from 'vue-axios'
import router from '@/router/index.js'
Vue.use(VueAxios, axios)
import { Message,MessageBox } from 'element-ui';
import { getCookie,delAllCookie } from '@/assets/js/cookie.js'
import {exportOrder} from '@/assets/js/Export/index.js'
Vue.prototype.$exportOrder = exportOrder
// 添加请求拦截器
let _this = this;
axios.interceptors.request.use( (config) => {
    // 在发送请求之前做些什么
    var userInfo = JSON.parse(getCookie('userInfo'))
	if(config.method == 'post'){
		config.data={
			...config.data,
			admin_id: userInfo.admin_id,
			ttl: userInfo.ttl,
			sign: userInfo.sign
		}
	}else{
		config.params={
			...config.params,
			admin_id: userInfo.admin_id,
			ttl: userInfo.ttl,
			sign: userInfo.sign
		}
	}
	return config
}, function (error) {
	// 对请求错误做些什么
	return Promise.reject(error)
})

axios.defaults.timeout = 100000;           //超时时间
axios.defaults.retry = 26;                 //请求次数
axios.defaults.retryDelay = 5000;         //请求间隙
//拦截相应response，并做一些错误处理
axios.interceptors.response.use((response) => {
	if(response.data.errno == '4002' || response.data.errno == '4001'){
		//登录超时或者多台设备登录
		Message.closeAll()
		delAllCookie();//清除所以的cookie
		// router.push("/");
		if(sessionStorage.getItem('reload') != '1'){
			location.reload();
		}
		sessionStorage.setItem('reload','1')
	}
	// 对响应数据做些事
	if (!response.data) {
		return Promise.reject(response)
	}
	return response
}, (error) => {
    if (error && error.response) {
        switch (error.response.status) {
            case 400:
                error.message = '请求错误'
                break

            case 401:
                error.message = '未授权，请登录'
                break

            case 403:
                error.message = '拒绝访问'
                break

            case 404:
                error.message = `请求地址出错404`
                break

            case 405:
                error.message = '请求不被允许，请检查接口调用方式'
                break

            case 408:
                error.message = '请求超时'
                break

            case 500:
                error.message = '服务器开个小差，请稍后再试'
                break

            case 501:
                error.message = '服务器开个小差，请稍后再试'
                break

            case 502:
                error.message = '服务器开个小差，请稍后再试'
                break

            case 503:
                error.message = '服务器开个小差，请稍后再试'
                break

            case 504:
                error.message = '服务器开个小差，请稍后再试'
                break

            case 505:
                error.message = 'HTTP版本不受支持'
                break

            default:
        }
    }
	return Promise.reject(error)
})

Vue.prototype.$axios = axios

Vue.prototype.$winopen =  (url) => {
    window.open(url,"_blank");

    // var open=true;
    // try{
    //     alert(window.open)
    // }catch(e){
    //     open = false;
    // }
    // if(open==false){
    //     alert("弹出页面被浏览器拦截");
    // }
}
//接口地址
Vue.prototype.URL = api
export {
	Vue
}




// WEBPACK FOOTER //
// ./src/assets/config/config.js